import * as React from 'react';
import { Provider } from 'react-redux';
import asyncDispatchMiddleware from 'async-dispatch';

import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { standaloneReducerBase } from './redux/RootStore';

const ReduxProvider: React.FunctionComponent<React.PropsWithChildren> = function ({ children }) {
    const rootReducer = combineReducers({
        ...standaloneReducerBase,
    });

    const rootStore = configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware().concat(asyncDispatchMiddleware),
        devTools: {
            name: 'L2D Pay Store',
        },
    });

    return <Provider store={rootStore}>{children}</Provider>;
};

export default ReduxProvider;
